import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/dueno-2-caja.webp")